{
  "<0>We are still processing this request.</0><1>Try back again later.</1>": "<0>We are still processing this request.</0><1>Try back again later.</1>",
  "A payment of {formatCentsToCurrency(calculatedAmount)} has been submitted {fullName && `for ${fullName}'s card.`}": "A payment of {formatCentsToCurrency(calculatedAmount)} has been submitted {fullName && `for ${fullName}'s card.`}",
  "ACH saved successfully!": "ACH saved successfully!",
  "Account, Chart, or Invoice Number*": "Account, Chart, or Invoice Number*",
  "Address line 1": "Address line 1",
  "Address line 2": "Address line 2",
  "An error occurred. Please try again. If you continue to get this message, please request a new link.": "An error occurred. Please try again. If you continue to get this message, please request a new link.",
  "Billing Information": "Billing Information",
  "City": "City",
  "Confirm Payment": "Confirm Payment",
  "Continue Editing": "Continue Editing",
  "Date of Birth*": "Date of Birth*",
  "Email": "Email",
  "Email*": "Email*",
  "Enter Billing Information": "Enter Billing Information",
  "Enter Credit Card Details": "Enter Credit Card Details",
  "Error creating confirmation. Stripe Elements not loaded yet. Try again!": "Error creating confirmation. Stripe Elements not loaded yet. Try again!",
  "Error creating confirmation. Stripe not loaded yet. Try again!": "Error creating confirmation. Stripe not loaded yet. Try again!",
  "Error processing payment with Stripe. Try again!": "Error processing payment with Stripe. Try again!",
  "Error processing payment with Stripe. {{errorMessage}}": "Error processing payment with Stripe. {{errorMessage}}",
  "Error processing your card. Please check your information and try again.": "Error processing your card. Please check your information and try again.",
  "Error retrieving payment intent. Please try again.": "Error retrieving payment intent. Please try again.",
  "Error submitting payment. Please try again.": "Error submitting payment. Please try again.",
  "First Name*": "First Name*",
  "Full name": "Full name",
  "If paying with a credit card, a surcharge will be applied. Debit cards and ACH payments will not.": "If paying with a credit card, a surcharge will be applied. Debit cards and ACH payments will not.",
  "Invalid information provided. Please fix the errors and resubmit.": "Invalid information provided. Please fix the errors and resubmit.",
  "Last Name*": "Last Name*",
  "Link expired. This Payment Plan has already been accepted/denied!": "Link expired. This Payment Plan has already been accepted/denied!",
  "Location ID is required": "Location ID is required",
  "Make another payment": "Make another payment",
  "Name": "Name",
  "Next": "Next",
  "Not provided": "Not provided",
  "Payment Amount*": "Payment Amount*",
  "Payment Details": "Payment Details",
  "Payment Method": "Payment Method",
  "Payment Request not complete": "Payment Request not complete",
  "Payment Successfully Submitted!": "Payment Successfully Submitted!",
  "Payment amount": "Payment amount",
  "Payment amount should not be less than $250 for ACH.": "Payment amount should not be less than $250 for ACH.",
  "Payment amount should not be more than $100,000 for ACH.": "Payment amount should not be more than $100,000 for ACH.",
  "Payment failed because of a card network error. Please try again or use a different payment method.": "Payment failed because of a card network error. Please try again or use a different payment method.",
  "Privacy Policy": "Privacy Policy",
  "Reset to full amount": "Reset to full amount",
  "State": "State",
  "Stripe not loaded yet. Try again!": "Stripe not loaded yet. Try again!",
  "Submission was invalid: {{message}}": "Submission was invalid: {{message}}",
  "Submit": "Submit",
  "Submit Payment": "Submit Payment",
  "The ACH payment method has been successfully added and will be automatically set as the default payment method.": "The ACH payment method has been successfully added and will be automatically set as the default payment method.",
  "There was a problem submitting your payment. Please try again with a different payment method.": "There was a problem submitting your payment. Please try again with a different payment method.",
  "There was an error processing your payment. Wait 30 seconds and try again.": "There was an error processing your payment. Wait 30 seconds and try again.",
  "Try again.": "Try again.",
  "Unable to load payment processor. Please contact support.": "Unable to load payment processor. Please contact support.",
  "View Invoice": "View Invoice",
  "Whoops!": "Whoops!",
  "ZIP Code": "ZIP Code",
  "empty onBehalfOf": "empty onBehalfOf"
}
